module.exports = __webpack_public_path__ + "img/2024-03-08b_2.609286da.jpg";